export default __webpack_public_path__ + "static/media/league-logo.2e7dc1d6.png";